import Cookies from 'js-cookie';
import { CookieAttributes } from 'js-cookie';
import { isCdkEnvironment, isEnvDevelopment } from './enviroments';
import { COOKIE_NAME } from './types';

const getDomain = (isEnvDevelopment: boolean, isCdkEnvironment: boolean) => {
  if (isEnvDevelopment) {
    return 'localhost';
  }

  if (isCdkEnvironment) {
    return '.connectcdk.com';
  }

  return '.covideo.com';
};

export const cookieOptions: CookieAttributes = {
  domain: getDomain(isEnvDevelopment, isCdkEnvironment),
  path: '/',
  secure: true,
  sameSite: 'none',
  expires: 7,
};
const updateCookie = (
  newToken: string,
  refreshTokenNew?: string | undefined,
  adminJwt?: string | undefined,
  domain?: string | undefined
) => {
  // Set domain only if not in development env
  if (domain && !isEnvDevelopment) {
    cookieOptions.domain = `.${domain}`;
  }
  Cookies.set(COOKIE_NAME.JWT, newToken, cookieOptions);
  if (refreshTokenNew) {
    Cookies.set(COOKIE_NAME.REFRESH_JWT, refreshTokenNew, cookieOptions);
  }

  if (adminJwt) {
    Cookies.set(COOKIE_NAME.ADMIN_JWT, adminJwt, cookieOptions);
  }

  if (adminJwt === undefined) {
    Cookies.remove(COOKIE_NAME.ADMIN_JWT, cookieOptions);
  }
};

export { updateCookie };
